/**
 * Factory function to create the Payment Element Web Component.
 * This consolidates the web component creation logic used by both
 * the module export and standalone versions.
 */
import r2wc from '@r2wc/react-to-web-component';

import { PaymentElementWrapper } from './components/PaymentElementWrapper';
import { PAYMENT_ELEMENT_PROPS_CONFIG } from './webComponentConfig';

/**
 * Creates a Payment Element Web Component class using r2wc.
 *
 * @returns The Web Component class ready for registration
 */
export const createPaymentElementWebComponent = () => {
  return r2wc(PaymentElementWrapper, {
    props: PAYMENT_ELEMENT_PROPS_CONFIG,
  });
};
